import { createSelector } from 'reselect'
import { State } from '../../reducers/reducerType'
import { mediaType as MediaType } from '@bt-react/constants'
import { PlayInStatus } from '../../../lib/playIn/types'

/**
 * Determines whether the current webcast has completed or not
 * @param state The Redux state
 */

const getMediaType = (state: State): MediaType => state.syncUi.mediaType
const getPlayInStatus = (state: State): PlayInStatus => state.playIn.status

export default createSelector(
  [getMediaType, getPlayInStatus],
  (mediaType, playInStatus) => {

    return (mediaType === MediaType.PLAY_IN && playInStatus === PlayInStatus.PLAYING) || mediaType === MediaType.EVENT_STREAM

  })
